module.exports = __webpack_public_path__ + "img/light-mobile.bda13862.svg";